import { render, staticRenderFns } from "./OsobaDodatnaAktivnostCreate.vue?vue&type=template&id=1c9f93d6&scoped=true&"
import script from "./OsobaDodatnaAktivnostCreate.vue?vue&type=script&lang=js&"
export * from "./OsobaDodatnaAktivnostCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9f93d6",
  null
  
)

export default component.exports